export const STANDARD_LAYOUT_EASE: [number, number, number, number] = [
  0.22,
  1,
  0.36,
  1,
];

export const STANDARD_LAYOUT_SETTINGS = {
  duration: 0.34,
  ease: STANDARD_LAYOUT_EASE,
};

export const STANDARD_LAYOUT_TRANSITION = {
  duration: 0.34,
  ease: STANDARD_LAYOUT_EASE,
  layout: STANDARD_LAYOUT_SETTINGS,
};
